export default "__VITE_ASSET__9fc7b76e__"